import { PartyTypes } from '../enums';

export interface BookedSlotInput {
  type?: PartyTypes;
  quoted_time: number;
  seated_time?: number | null;
}

/**
 * Whether a party occupies its booked slot: a reservation that is not seated yet or was seated
 * before its slot ended. A reservation seated after its slot ended is a new seating and, like a
 * walk-in, runs from its seated time.
 */
export function keepsBookedSlot(party: BookedSlotInput, duration: number): boolean {
  if (party.type !== PartyTypes.reservation) {
    return false;
  }

  const seated = party.seated_time ?? null;

  return seated === null || seated < party.quoted_time + duration;
}
